import { CloseOutlined, EditOutlined} from "@ant-design/icons";
import { Modal } from "antd";
import { useContext } from "react";
import UploadingProcessContext from "../../context/uploadingProcessContext";

export function CustomModal({
  loading,
  size,
  visible,
  footer,
  title,
  onOk,
  handleCancel,
  children,
}) {
  const { uploading } = useContext(
    UploadingProcessContext
  );

  return (
    <Modal
      closable={false}
      width={size}
      title={title}
      open={visible}
      onOk={onOk}
      onCancel={handleCancel}
      cancelText="لغو"
      okText="اعمال تغییر"
      okButtonProps={{
        disabled: uploading,
        type: "primary",
        ghost: false,
        loading:loading,
        icon: <EditOutlined />,
        style: { backgroundColor: "#005AC8", fontFamily: "IRANSansX" },
      }}
      cancelButtonProps={{
        disabled: uploading,
        type: "primary",
        ghost: false,
        icon: <CloseOutlined />,
        style: { backgroundColor: "#B8083D", fontFamily: "IRANSansX" },
      }}
      footer={footer}
    >
      {children}
    </Modal>
  );
}
